import { DocumentTypes } from "@inosio/payments-sdk";
export const getUserFriendlyStringFromCapitalized = (str: string) => str.split(/(?=[A-Z])/).join(" ");

export const getFriendlyWordsFromDocumentType = (docType: string): string => {
    switch (docType) {
        case DocumentTypes.Companylegalese:
            return "Company legalese";
        case DocumentTypes.OwnerDocumentOther:
            return "Other"
        case DocumentTypes.Ftp:
            return DocumentTypes.Ftp;
        case DocumentTypes.GovIssuedId:
            return "Gov Issued ID";
        default:
            break;

    }
    return getUserFriendlyStringFromCapitalized(docType);
};